export default {
    name: 'inputscancelled',
    component: () => import(/* webpackChunkName: "inputs-cancelled-layout" */ '@/modules/inputs/cancelled/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.inputs.cancelled.index',
            component: () => import(/* webpackChunkName: "inputs-cancelled-index" */ '@/modules/inputs/cancelled/views/Index'),
        },
    ]
}